import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title',
		defaultMessage: 'Create',
		description: 'Title for issue create modal',
	},
	titleIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title-issue-terminology-refresh-m4',
		defaultMessage: 'Create {issueType}',
		description: 'Title for issue create modal. Please translate as “work type {issueType}”',
	},
	subtaskTitle: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.subtask-title',
		defaultMessage: 'Create subtask',
		description: 'Title for subtask create modal',
	},
	createLinkedIssueDialogTitle: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title',
		defaultMessage: 'Create linked issue',
		description: 'Title of the create linked issue dialog.',
	},
	changerButtonsDisabledForgeFields: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields',
		defaultMessage: 'Some fields in this project and issue type don’t allow resizing or minimizing',
		description:
			'The tooltip when the changer buttons on the GIC are disabled when forge fields or ui modifications are detected',
	},
	createLinkedIssueDialogTitleIssueTermRefresh: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title-issue-term-refresh',
		defaultMessage: 'Create linked work item',
		description: 'Title of the create linked issue dialog.',
	},
	changerButtonsDisabledForgeFieldsIssueTermRefresh: {
		id: 'issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields-issue-term-refresh',
		defaultMessage: 'Some fields in this project and work type don’t allow resizing or minimizing',
		description:
			'The tooltip when the changer buttons on the GIC are disabled when forge fields or ui modifications are detected',
	},
});
